import {makeObserver} from "../../topic/topic";
import {makeFilterResultHtml, makeFilterResultTopic} from "./filter-result-topic";

function updateSearchResult(html) {
    document.querySelector("#catalogue-magazine-search-result-container .catalogue-magazine-presenter-container .catalogue-results-magazine-separator").innerHTML = html
}

function showInitialMagazines() {
    document.querySelector('.catalogue-magazine-presenter-container').classList.remove('hidden')
}

function hideInitialMagazines() {
    document.querySelector('.catalogue-magazine-presenter-container').classList.add('hidden')
}

function showResults() {
    document.querySelector('#catalogue-magazine-search-result-container').classList.remove('hidden')
}

function hideResults() {
    document.querySelector('#catalogue-magazine-search-result-container').classList.add('hidden')
}

export default function (isFilterSet) {
    const haveResultsObserver = makeObserver((subject) => {
        if (!isFilterSet()) {
            hideResults()
            showInitialMagazines()
        } else {
            const html = makeFilterResultHtml(subject.getState().results)
            hideInitialMagazines()
            showResults()
            updateSearchResult(html)
        }
    })

    return makeFilterResultTopic([haveResultsObserver])
}